<template>
  <van-popup v-model="popShow" :close-on-click-overlay="true" :position="$store.state.isMirroring ? 'right' : 'left'">
    <div class="setting_drawer" :style="{ paddingTop: `calc(${$store.state.statusBarHeight}px + 0.12rem)` }">
      <!-- 钱包账户信息 -->
      <div class="subtitle">{{ $t('basicLevel.identityVerification') }}</div>
      <div class="drawer_item" @click="openIdentityVerification">
        <div :class="$store.state.isMirroring && 'mirror'" class="item_left">
          <img class="item_icon" src="@/assets/home/icon_wallet_account.png" alt="" />
          {{ $t('basicLevel.identityVerification') }}
        </div>
        <div v-if="level < 2" class="item_right">
          <div class="tag">{{ $t('redesign.toComplete') }}</div>
        </div>
      </div>
      <!-- <div :class="$store.state.isMirroring && 'mirror'" class="drawer_item" @click="toTransferPage">
        <div class="item_left">
          <img class="item_icon" src="@/assets/home/icon_transfer.png" alt="" />
          {{ $t('transfer.transfer') }}
        </div>
      </div> -->
      <!-- 银行卡账户信息 -->
      <div class="subtitle">{{ $t('redesign.bankCardInfo') }}</div>
      <div class="drawer_item" @click="toMyLinkedAccount">
        <div :class="$store.state.isMirroring && 'mirror'" class="item_left">
          <img class="item_icon" src="@/assets/home/icon_withdraw_account.png" alt="" />
          {{ $t('redesign.withdrawInfo') }}
        </div>
        <div v-if="!hasWithdrawMethod" class="item_right">
          <div class="tag">{{ $t('redesign.toFillIn') }}</div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { toVerifyPage } from '@/service'

export default {
  name: 'HomeWalletDrawer',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    hasWithdrawMethod: {
      type: Boolean,
      default: false
    },
    level: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      popShow: false
    }
  },
  watch: {
    value(val) {
      this.popShow = val
    },
    popShow(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    toVerifyPage,
    openIdentityVerification() {
      this.toVerifyPage({ from: 'sidebar' })
    },
    // toTransferPage() {
    //   this.$router.push({ name: 'Transfer' })
    // },
    toMyLinkedAccount() {
      this.$router.push({ name: 'MyLinkedAccount' })
    }
  }
}
</script>

<style scoped>
.setting_drawer {
  width: 3rem;
  height: 100%;
  background: #fff;
  padding: 0.12rem 0.16rem 0;
  box-sizing: border-box;
  overflow-y: auto;
}

.subtitle {
  display: flex;
  padding: 0.12rem 0 0.04rem;
  color: #828282;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 600;
}

.drawer_item {
  width: 100%;
  height: 0.6rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.item_left {
  display: flex;
  align-items: center;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
  text-align: left;
}

.item_left.mirror {
  text-align: right;
}

.item_icon {
  width: 0.3rem;
  height: 0.3rem;
  margin-inline-end: 0.12rem;
}

.item_right {
  color: #aaa;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 400;
}

.tag {
  display: flex;
  min-height: 0.2rem;
  padding: 0 0.08rem;
  align-items: center;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.1rem;
  font-style: normal;
  font-weight: 600;
  border-radius: 0.04rem;
  background: #d6d6d6;
}
</style>

<style>
.van-popup--right,
.van-popup--left {
  height: 100%;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/HomeWalletDrawer.vue